// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import consumer from "./channels/consumer"

// Make consumer available globally for views
window.consumer = consumer
